
import React from 'react';
import PropTypes from "prop-types";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        minWidth: 550,
        maxWidth: 500
    },

});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    const onLogout = () => {
        window.localStorage.clear();
        window.location.replace("#/login");
    }
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    color="primary"
                    className={classes.btnLogout}
                    onClick={onLogout}
                    size="large">
                    Logout
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    buttonPanel: {
        marginTop: 30,
        marginBottom: 20,
        justifyContent: 'center',
        display: 'flex'
    },
    btnLogout: {
        fontSize: 14,
        textDecoration: "underline"
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const LoginMenu = props => {

    const { handleClose, open, reload } = props;
    const classes = useStyles();
    const [show, setShow] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const onFormSubmit = async e => {

        setError('');
        e.preventDefault();
        const data = new FormData(e.target);
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/authentication/C01Authenticate`;
        await fetch(url, { method: "POST", body: data })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.success === 1) {


                        window.localStorage.setItem("userData", JSON.stringify(json));
                        window.localStorage.setItem("uclToken", json.jwttoken);
                        window.localStorage.setItem("isSaved", json.isApplicationSaved);
                        window.localStorage.setItem("applicationId", json.applicationId);

                        window.localStorage.setItem("isSubmitted", json.isApplicationSubmitted);
                        window.localStorage.setItem("isChallanUploaded", json.isChallanUploaded);
                        window.localStorage.setItem("degreeId", json.degreeId);
                        window.localStorage.setItem("degreeLabel", json.degreeLabel);
                        window.localStorage.setItem("firstName", json.firstName);
                        window.localStorage.setItem("lastName", json.lastName);
                        window.localStorage.setItem("dateOfBirth", json.dateOfBirth);
                        window.localStorage.setItem("email", json.email);
                        window.localStorage.setItem("genderId", json.genderId);
                        window.localStorage.setItem("mobileNo", json.mobileNo);
                        handleClose();
                        if (reload) {
                            window.location.reload();
                        }
                    } else {
                        setError('Wrong Password');

                    }
                },
                error => {
                    setError('Wrong Password');
                    console.log(error);
                });

        setIsLoading(false);
    }
    const handleClickShowPassword = () => {
        const update = !show;
        setShow(update);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onLogout = () => {
        window.localStorage.removeItem("userData");
        window.localStorage.removeItem("uclToken");
        window.localStorage.removeItem("isSaved");
        window.localStorage.removeItem("isSubmitted");
        window.localStorage.removeItem("isChallanUploaded");
        window.localStorage.removeItem("isTuitionFeeChallanUploaded");
        window.localStorage.removeItem("isDocumentRequested");
        window.localStorage.removeItem("applicationId");
        window.localStorage.removeItem("email");
        window.location.replace("#/login");
    }

    return (
        <div>
            <Dialog
                disableScrollLock
                disableEscapeKeyDown
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title">
                    Login
                </DialogTitle>
                <DialogContent>
                    <span>Your session has been expired, Please login to continue.</span>
                    <form onSubmit={e => onFormSubmit(e)} className={classes.form}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            disabled
                            value={window.localStorage.getItem("email")}
                            fullWidth
                            label="Email Address"
                        />
                        <input type="hidden" value={window.localStorage.getItem("email")} name="email" />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            onChange={() => setError('')}
                            type={show ? "text" : "password"}
                            id="password"
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            size="large">
                                            {show ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>

                            }}
                        />
                        <span style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '-12px',
                            color: '#e04848'
                        }}>{error}</span>
                        <div className={classes.buttonPanel}>
                            <Button type="submit"
                                variant="contained"
                                style={{ backgroundColor: `${isLoading ? "#6272ce" : ""}`, width: '85%' }}
                                color="primary"
                                disabled={isLoading}>
                                {isLoading ? <CircularProgress style={{ color: 'white' }} size={24} /> : "Login"}
                            </Button>
                            <span style={{
                                fontSize: 30,
                                marginLeft: 5,
                                opacity: '0.4'
                            }}>|</span>
                            <IconButton
                                color="primary"
                                className={classes.btnLogout}
                                onClick={onLogout}
                                variant="body2"
                                size="large">
                                Logout
                                </IconButton>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>
        </div >
    );
}

LoginMenu.propTypes = {
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    reload: PropTypes.bool
};

LoginMenu.defaultProps = {
    handleClose: fn => fn,
    open: false,
    reload: false
};

export default LoginMenu;